export default __webpack_public_path__ + "static/media/icon_close_small.9e4c3a50.svg";